import React from "react";

const HeightBody = () => {
  return (
    <div>
      <h2>Height Body Content</h2>
    </div>
  );
};

export default HeightBody;
